import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  forgetPasswordReducer,
  resetPasswordReducer,
  userLoginReducer,
  userRegisterReducer,
  userRequestParticipatingMerchantReducer,
} from "./reducers/userReducer";
import {
  createOrderReducer,
  orderDetailsReducer,
  orderListMyReducer,
} from "./reducers/orderReducer";
import { authSignupReducer , authSigninReducer } from "./reducers/authPaymentReducer";

const reducer = combineReducers({
  userLogin: authSigninReducer,
  userRegister: authSignupReducer,
  order: createOrderReducer,
  orderDetails: orderDetailsReducer,
  requestParticipatingMerchant: userRequestParticipatingMerchantReducer,
  myOrders: orderListMyReducer,
  forgetPassword: forgetPasswordReducer,
  resetPassword: resetPasswordReducer,
  authSignup: authSignupReducer, // Add the authSignupReducer
  //   userDetails: userDetailsReducer,
  //   userUpdateProfile: userUpdateProfileReducer,
});

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const initialState = {
  userLogin: { userInfo: userInfoFromStorage },
};

console.log("initialState",initialState)

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
